// Custom method for walking errors since BaseError walk from wagmi and viem differ
export function walk(error: unknown, fn: (error: unknown) => boolean) {
  if (fn(error)) {
    return error
  }
  if (
    error &&
    typeof error === "object" &&
    "cause" in error &&
    error.cause !== undefined
  ) {
    return walk(error.cause, fn)
  }
  return null
}
